import React from 'react';

import ProfileImage from './ProfileImage';
import EmojiImage from './EmojiImage';
import Initials from './Initials';

function Avatar(props) {
  if (props.participant.image) {
    return <ProfileImage src={props.participant.image} />;
  } else if (props.participant.me) {
    return <EmojiImage src={props.participant.image} />;
  } else {
    return <Initials name={props.participant.name} surname={props.participant.surname} />;
  }
}

export default Avatar;
